module.exports = __webpack_public_path__ + "static/media/Neuroimaging  - Icon.2e3742d0.svg";